import { useNavigate } from 'react-router-dom';
import { APP_ROUTES, OrgType } from '@/config/constants';
import { BodyMediumMidEmphasis, TitleSmallEmphasized } from '@/design-system';
import colors from '@/theme/colors';
import styles from './SubscriptionsBanner.styles';
import { AccessibleDivButton } from '@/components';

type Props = {
  type: string;
  institutionName?: string;
  schools: string[];
};

const MAX_NUMBER_SCHOOLS = 5;

const SubscriptionsBanner: React.FC<Props> = ({ type, institutionName, schools }) => {
  const navigate = useNavigate();
  const slidedSchools = schools.slice(0, MAX_NUMBER_SCHOOLS);
  const hasMoreSchools = schools.length > MAX_NUMBER_SCHOOLS;
  const amountExtraSchools = schools.length - MAX_NUMBER_SCHOOLS;
  const adjustCommunityArea = () => {
    navigate(APP_ROUTES.community);
  };
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <TitleSmallEmphasized nonTranslate>{institutionName}</TitleSmallEmphasized>
      </div>
      <div className={styles.schoolsContainer}>
        {type === OrgType.school ? (
          <>
            {slidedSchools.length > 1 &&
              slidedSchools.map((schoolName, schoolIndex) => (
                <span key={schoolName}>
                  <BodyMediumMidEmphasis data-testid="school" nonTranslate color={colors.charcoal}>
                    {schoolName}
                  </BodyMediumMidEmphasis>
                  {schoolIndex < slidedSchools.length - 1 && (
                    <span className={styles.separator}>{' • '}</span>
                  )}
                </span>
              ))}
            {hasMoreSchools && (
              <BodyMediumMidEmphasis color={colors.charcoal}>
                {` and ${amountExtraSchools}+`}
              </BodyMediumMidEmphasis>
            )}
          </>
        ) : (
          <AccessibleDivButton onClick={adjustCommunityArea}>
            <BodyMediumMidEmphasis className={styles.adjustArea} color={colors.shadesJungle800}>
              Adjust my community area
            </BodyMediumMidEmphasis>
          </AccessibleDivButton>
        )}
      </div>
    </div>
  );
};

export default SubscriptionsBanner;
